//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import Month from '../../common/functions/month'; // eslint-disable-line
import * as monthClasses from '../../common/functions/month'; // eslint-disable-line

export default {
  props: {
    initialDate: {
      type: Object,
      default() {
        moment.locale(this.lang || 'pt-br');
        return moment();
      },
    },
    disablePassedDays: { type: Boolean, default: false },
    disablePreviousDays: { type: String, default: null },
    disablePassedMonths: { type: Boolean, default: false },
    disabledDays: { type: Array, default() { return []; } },
    format: { type: String, default: 'DD/MM/YYYY' },
    doubled: { type: Boolean, default: false },
    lang: { type: String, default: 'pt-br' },
    orientation: { type: String, default: 'portrait' },
    show: { type: Boolean, required: true },
    showActions: { type: Boolean, required: false, default: false },
    isDatepicker: { type: Boolean, required: false, default: false },
    noheader: { type: Boolean, default: false },
  },
  data() {
    return {
      date: '',
      weekDays: monthClasses.getWeekDays(this.lang),
      months: [],
      classDirection: 'off',
      dayDirection: 'off',
      yearsVisible: false,
      years: null,
    };
  },
  computed: {
    year() {
      return this.date.format('YYYY');
    },
    dateFormatted() {
      if (this.orientation === 'landscape') {
        return (this.lang === 'en' || this.lang === 'en-us') ?
          `${this.date.format('dddd')},<br>${this.date.format('MMM DD')}` :
          `${this.date.format('ddd DD')},<br>${this.date.format('MMMM')}`;
      }
      if (this.doubled) {
        return (this.lang === 'en' || this.lang === 'en-us') ?
          `${this.date.format('dddd')}, ${this.date.format('MMMM DD')}` :
          this.date.format('dddd DD MMMM');
      }

      return (this.lang === 'en' || this.lang === 'en-us') ?
        `${this.date.format('dddd')}, ${this.date.format('MMM DD')}` :
        this.date.format('dddd DD MMM');
    },
    classOrientation() {
      return this.orientation;
    },
    isDoubled() {
      if (this.doubled) return 'double';
      return '';
    },
    language() {
      const tmp = ['ok', 'cancel'];

      if (this.lang === 'da') {
        tmp[1] = 'afbestille';   // Danish
      }
      if (this.lang === 'nl') {
        tmp[1] = 'annuleren';    // Dutch
      }
      if (this.lang === 'de') {
        tmp[1] = 'abbrechen';    // German
      }
      if (this.lang === 'es' || this.lang === 'es-do') {
        tmp[1] = 'cancelar'; // Spanish and spanish (Dominican Republic)
      }
      if (this.lang === 'fi') {
        tmp[1] = 'peruuttaa';    // Finish
      }
      if (this.lang === 'fr' || this.lang === 'fr-ca' || this.lang === 'fr-ch') {
        tmp[1] = 'annuler'; // French(France-Canada-Switzerland)
      }
      if (this.lang === 'hu') {
        tmp[1] = 'megszünteti';  // Hugarian
      }
      if (this.lang === 'it') {
        tmp[1] = 'annullare';    // Italian
      }
      if (this.lang === 'lb') {
        tmp[1] = 'annuléieren';  // Luxembourgish
      }
      if (this.lang === 'nb') {
        tmp[1] = 'avbryte';      // Norwegian
      }
      if (this.lang === 'pl') {
        tmp[1] = 'anulować';     // Polish
      }
      if (this.lang === 'pt' || this.lang === 'pt-br') {
        tmp[1] = 'cancelar'; // Portuguese and Portuguese(Brazil)
      }
      if (this.lang === 'ro') {
        tmp[1] = 'anula'; // Romaninan
      }
      if (this.lang === 'ru') {
        tmp[1] = 'отменить'; // Romaninan
      }
      if (this.lang === 'sk') {
        tmp[1] = 'zrušiť'; // Slovak
      }
      if (this.lang === 'sl') {
        tmp[1] = 'preklic'; // Slovenian
      }
      if (this.lang === 'sv') {
        tmp[1] = 'avboka'; // Swedish
      }
      if (this.lang === 'uk') {
        tmp[1] = 'preklic'; // Ukrainian
      }

      return tmp;
    },
  },
  watch: {
    show(val) {
      if (val === false) {
        this.classDirection = 'off';
        this.dayDirection = 'off';
        return;
      }
      const newDate = moment([
        this.date.year(),
        this.date.month(),
        this.date.date(),
      ]);
      this.date = newDate.clone();
    },
    yearsVisible() {
      const scrollOffset = (this.date.year() - this.years[0].year()) * 40 - 130; //eslint-disable-line
    },
  },
  methods: {
    classYear(year) {
      if (year.year() === this.date.year()) {
        return 'selected';
      }
      return '';
    },
    isDisabled(day) {
      if (this.disabledDays.length > 0) {
        for (let i = 0; i < this.disabledDays.length; i += 1) {
          const currDisabledDay = moment(this.disabledDays[i], 'YYYY-MM-D'),
            startDay = currDisabledDay.startOf('day').unix();
          if (startDay === day.startOf('day').unix()) {
            return true;
          }
        }
      }

      if (this.disablePreviousDays) {
        return day < moment(this.disablePreviousDays, this.format).startOf('day');
      }

      if (this.disablePassedDays) {
        return day < moment().startOf('day');
      }

      if (this.disablePassedMonths) {
        return day < moment().startOf('month');
      }
      return false;
    },
    isSelected(day) {
      return this.date.unix() === day.unix();
    },
    selectDate(newDate) {
      if (!this.isDisabled(newDate)) {
        this.classDirection = 'off';
        this.setClassDirection(newDate);
        this.date = newDate.clone();
        this.$emit('clicked-day', newDate);
      }
    },
    selectYear(date) {
      this.setClassDirection(date);

      const newDate = moment([date.year(), this.date.month(), this.date.date()]);
      this.date = newDate.clone();

      this.setMonths();

      const scrollOffset = (this.date.year() - this.years[0].year()) * 40 - 130; // eslint-disable-line
      this.showOrHideYears();

      this.$emit('change', this.date);
    },
    setClassDirection(date) {
      this.dayDirection = 'direction-next';
      if (date.isBefore(this.date)) this.dayDirection = 'direction-prev';
    },
    setMonths() {
      const newMonths = [],
        firstMonth = new Month(this.date.month(), this.date.year());
      newMonths.push(firstMonth);

      if (this.doubled) {
        let mon = this.date.month() + 1;
        let year = this.date.year();

        if (mon > 11) {
          mon = 0;
          year += 1;
        }

        const secondMonth = new Month(mon, year);
        newMonths.push(secondMonth);
      }

      this.months = newMonths;
    },
    nextMonth() {
      const tmpMonths = [],
        monthsLength = this.months.length - 1;

      for (let i = 0; i < monthsLength; i += 1) {
        tmpMonths.push(new Month(this.months[i + 1].month,
          this.months[i + 1].year));
      }

      let mon = this.months[monthsLength].month + 1;
      let year = this.months[monthsLength].year;

      if (mon > 11) {
        mon = 0;
        year += 1;
      }

      const tmpMonth = new Month(mon, year);
      tmpMonths.push(tmpMonth);

      this.classDirection = 'direction-next';
      this.months = tmpMonths;
    },
    prevMonth() {
      const tmpMonths = [],
        monthsLength = this.months.length - 1;

      for (let i = monthsLength; i > 0; i -= 1) {
        tmpMonths.push(new Month(this.months[i - 1].month,
          this.months[i - 1].year));
      }

      let mon = this.months[0].month - 1;
      let year = this.months[0].year;

      if (mon < 0) {
        mon = 11;
        year -= 1;
      }

      const tmpMonth = new Month(mon, year);
      tmpMonths.unshift(tmpMonth);

      this.classDirection = 'direction-prev';
      this.months = tmpMonths;
    },
    submitDay() {
      this.classDirection = 'off';
      this.dayDirection = 'off';
      this.yearsVisible = false;
      this.$emit('change', this.date);
      this.$emit('hide');
    },
    cancel() {
      this.classDirection = 'off';
      this.dayDirection = 'off';
      this.$emit('cancel');
    },
    showOrHideYears() {
      this.yearsVisible = !this.yearsVisible;
    },
  },
  created() {
    moment.locale(this.lang);
    this.date = this.initialDate.clone();
  },
  mounted() {
    this.$nextTick(() => {
      this.setMonths();
      this.years = this.months[0].getYears();
    });
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/datepicker/Datepicker.vue?vue&type=script&lang=js&